module.exports = __webpack_public_path__ + "img/icon_03@2x.d5540824.png";